import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Modal from '../../components/modal'
import Select from '../../components/select'
import general from '../../utils/general'
import { Actions as ApiCallActions } from '../../redux/apiCall/reducers'

const AssignAgentModal = ({ isOpen, student, onClose, onAssigned }) => {
  const dispatch = useDispatch()
  const [availableAgents, setAvailableAgents] = useState([])
  const [selectedAgentId, setSelectedAgentId] = useState('')
  const [agentsLoading, setAgentsLoading] = useState(false)
  const [assigningAgent, setAssigningAgent] = useState(false)

  useEffect(() => {
    if (!isOpen) return

    setSelectedAgentId('')
    setAgentsLoading(true)
    dispatch(
      ApiCallActions.Get({
        url: 'agents/active',
        showAlertOnError: true,
        onSuccess: ({ data }) => {
          const agents = data?.data || data || []
          const options = agents.map((agent) => ({
            value: agent.id || agent.userId || agent.agentId,
            label:
              agent.companyName
          })).filter((option) => option.value && option.label)

          setAvailableAgents(options)
          setAgentsLoading(false)
        },
        onError: ({ errorMessage }) => {
          if (errorMessage) {
            general.notificationError(errorMessage)
          }
          setAvailableAgents([])
          setAgentsLoading(false)
        }
      })
    )
  }, [isOpen])

  const handleAssignAgent = () => {
    if (!student || !selectedAgentId) return

    setAssigningAgent(true)
    dispatch(
      ApiCallActions.Post({
        url: `students/${student.id}/assign-agent/${selectedAgentId}`,
        showAlertOnError: true,
        showLoading: true,
        onSuccess: () => {
          general.messageSuccess('Acenta başarıyla atandı')
          if (onAssigned) {
            onAssigned()
          }
          handleClose()
        },
        onError: ({ errorMessage }) => {
          if (errorMessage) {
            general.notificationError(errorMessage)
          }
        },
        callback: () => {
          setAssigningAgent(false)
        }
      })
    )
  }

  const handleClose = () => {
    onClose()
    setSelectedAgentId('')
    setAssigningAgent(false)
  }

  const renderStudentLabel = () => {
    if (!student) return '-'
    const fullName = `${student?.user?.firstName || ''} ${student?.user?.lastName || ''}`.trim()
    return fullName || student?.user?.email || '-'
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Acenta Ata"
      subtitle="Sadece admin kullanıcılar acenta atayabilir"
      icon="zmdi-accounts"
      size="medium"
    >
      {student && (
        <>
          <div className="m-b-20">
            <strong>Öğrenci:</strong> {renderStudentLabel()}
          </div>

          <div className="form-group">
            <label className="d-block m-b-10">Acenta Seç</label>
            <Select
              name="agentId"
              value={selectedAgentId}
              onChange={(e) => setSelectedAgentId(e.target.value)}
              placeholder={agentsLoading ? 'Acentalar yükleniyor...' : 'Acenta seçiniz'}
              options={availableAgents}
              disabled={agentsLoading}
              required
            />
            {!agentsLoading && availableAgents.length === 0 && (
              <small className="text-muted">Aktif acenta bulunamadı.</small>
            )}
          </div>

          <div className="text-right m-t-20">
            <button
              type="button"
              className="btn btn-default btn-round m-r-10"
              onClick={handleClose}
              disabled={assigningAgent}
            >
              İptal
            </button>
            <button
              type="button"
              className="btn btn-primary btn-round"
              onClick={handleAssignAgent}
              disabled={!selectedAgentId || assigningAgent}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
            >
              {assigningAgent ? (
                <>
                  <i className="zmdi zmdi-time-restore"></i>
                  <span>Atanıyor...</span>
                </>
              ) : (
                <>
                  <i className="zmdi zmdi-check"></i>
                  <span>Acenta Ata</span>
                </>
              )}
            </button>
          </div>
        </>
      )}
    </Modal>
  )
}

export default AssignAgentModal

